import axios from '../axios';

export default {
  getUsers (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/user?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getUser (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/user/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newUser (params) {
    return new Promise((resolve, reject) => {
      axios.post('/user', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateUser (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/user/${data.id}`, { ...data })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  toggleBlockUser (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/user/${data.id}/toggle`, { ...data })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  deleteUser (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/user/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getAllSettingsTables () {
    return new Promise((resolve, reject) => {
      axios.get('/user/all-table-settings')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  showSettingTable (id, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/user/${id}/table-setting`, {
        params: data,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateSettingTable (data) {
    return new Promise((resolve, reject) => {
      axios.post(`/user/${data.id}/table-setting`, { ...data })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
